import React from "react";
import { twJoin } from "tailwind-merge";
import { RowConfig } from "../types";
import { SupGripX, SupPlus, SupXCircle } from "@repo/core-ui";

export interface RowControlsProps {
  index: number;
  valid?: boolean;
  rowConfig?: RowConfig;
  dragRef?: (el: HTMLButtonElement) => void;
  onInsert: (index: number) => void;
  onDelete: (index: number) => void;
}

export function RowControls({ index: rowIndex, valid: isValid = true, rowConfig = { delete: true, move: true, insert: true }, dragRef, onInsert, onDelete }: RowControlsProps) {
  return (
    <span
      onClick={e => {
        e.stopPropagation();
      }}
      className={twJoin("sup-array-field-controls hidden gap-1 shrink-0")}
    >
      <button
        disabled={!isValid || !rowConfig.insert}
        onClick={() => {
          onInsert(rowIndex + 1);
        }}
        className="w-10 transition-colors duration-200 enabled:hover:text-neutral-900 disabled:opacity-44"
      >
        <SupPlus />
      </button>

      <button
        disabled={!rowConfig.move}
        ref={rowConfig.move ? dragRef : undefined}
        className="sup-array-field-drag-control w-10 transition-colors duration-200 enabled:hover:text-neutral-900 disabled:opacity-44"
      >
        <SupGripX />
      </button>

      <button
        disabled={!rowConfig.delete}
        onClick={() => {
          onDelete(rowIndex);
        }}
        className="w-10 transition-colors duration-200 enabled:hover:text-neutral-900 disabled:opacity-44"
      >
        <SupXCircle />
      </button>
    </span>
  );
}
